import React from "react";
import Grid from "@material-ui/core/Grid";
import HeaderAll from "../../HeaderAll";

function HeaderConferm(props) {

  const { found ,dataConfirm} = props;
  const styf = { fontWeight: "1200" };

  return (
    <Grid item container justifyContent="center" style={{fontWeight: "bold", fontFamily: "Amiri-Regular", }}>
      <HeaderAll Report={true}  found={found} />

      <Grid item container style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}>
      <Grid item xs={1}></Grid>
        <Grid item xs={10} style={{
          fontFamily: "Amiri-Regular", border: "solid 2px", paddingTop: "0.5rem",
           paddingBottom: "0.5rem",
          borderRadius: "10px", textAlign: "center", backgroundColor:"#1eFFFF"
        }}
        >
          <div style={styf}>
            {dataConfirm?.title} {"    "} {"من تاريخ"}{"    /"} {dataConfirm?.fDate}{"    "}  {"إلى تاريخ"}{"     /"} {dataConfirm?.tDate}
          </div>
        </Grid>
        <Grid item xs={1}></Grid>

      </Grid>

    </Grid>
  );
}
export default HeaderConferm;